// ============================================================
//  Global tuning + configuration
// ============================================================

export const TILE = 2;            // world size of one dungeon tile (units)
export const WALL_H = 2.6;        // wall block height
export const PLAYER_R = 0.5;      // collision radius (in tile units * TILE)
export const WALL_MARGIN = 0.1;   // small clearance so bodies don't clip wall faces (kept low so nothing snags)
export const STORY_H = 2.2;       // vertical rise between stacked dungeon stories

// ---- Dungeon generation ----
export const GRID_W = 40;
export const GRID_H = 40;
export const BASE_ROOMS = 6;

// ---- Camera ----
export const CAMERA = {
  distance: 26,      // how far the camera sits from its target
  pitch: 52,         // downward tilt in degrees (Minecraft-Dungeons-ish)
  fov: 32,           // narrow FOV flattens perspective toward isometric
  followLerp: 0.12,  // how quickly the camera catches up to the player
  rotateLerp: 0.15,  // how quickly snap-rotation eases
  snapStep: 45,      // degrees per Q/E press
};

// ---- Gameplay tuning ----
export const GAME = {
  playerBaseHp: 100,
  playerSpeed: 6.5,      // units / second
  rollSpeed: 16,
  rollTime: 0.22,
  rollCooldown: 0.7,
  enemyBaseCount: 12,   // floor 1 baseline (~2x the old count)
  enemyPerFloor: 5,
  lootDropChance: 0.55,
  invCap: 20,           // bag carrying capacity (equipped gear doesn't count)
  dungeonHazards: true, // environmental traps in dungeon floors (spike-grates, toxic grates, lava grates; damage players AND enemies). Set false to disable everywhere.
  lockedVaults: true,   // locked chests (tiered, cost Vault Keys) + sealed vault rooms in the dungeon. Set false to disable placement everywhere.

  // Stamina (universal): powers dodge-rolls + blocking. Regenerates.
  playerMaxStamina: 100,
  staminaRegen: 22,     // per second
  rollStamina: 26,      // cost of a dodge-roll
  blockStamina: 15,     // drain per second while blocking

  // Mana (class-gated): powers magic weapons. Refilled by kills/potions.
  manaRegen: 5,         // per second
  manaPerKill: 6,       // restored per enemy slain
  magicManaCost: 14,    // per magic-weapon cast
};

// Difficulty presets — scale enemy COUNT and STATS on top of per-floor ramp.
export const DIFFICULTIES = [
  { id: "recruit",   name: "Recruit",   countMult: 0.7, statMult: 0.8 },
  { id: "veteran",   name: "Veteran",   countMult: 1.0, statMult: 1.0 },
  { id: "nightmare", name: "Nightmare", countMult: 1.5, statMult: 1.35 },
];
export const DEFAULT_DIFFICULTY = "veteran";

// ---- Asset manifest -------------------------------------------------------
// Drop KayKit (or any) GLTF files into /public/assets/** and point these
// paths at them. If a file is missing, the engine falls back to a built-in
// blocky placeholder so the game always runs. See README.md.
export const ASSETS = {
  // Dungeon tiles (KayKit - Dungeon Pack Remastered)
  floor:  "assets/dungeon/floor_tile_large.gltf",
  wall:   "assets/dungeon/wall.gltf",
  // Characters (KayKit - Adventurers)
  hero:   "assets/characters/knight.gltf",
  enemy:  "assets/characters/skeleton_minion.gltf",
};

// Rarity tiers (shared by weapons + armor)
export const RARITY = [
  { name: "Common",   color: "#c8c8c8", mult: 1.0,  weight: 52 },
  { name: "Uncommon", color: "#5fd35f", mult: 1.15, weight: 28 },
  { name: "Rare",     color: "#4aa3ff", mult: 1.35, weight: 14 },
  { name: "Epic",     color: "#c77dff", mult: 1.65, weight: 6  },
  // Legendary never rolls from loot (weight 0) — earned ONLY from the Helix of
  // Restoration as Memory Relics.
  { name: "Legendary", color: "#f0a63c", mult: 2.15, weight: 0 },
];
